import firebaseApp from '../../../../services/firebaseService';
import { BasicBaseHelper, IBasicBaseClass } from '../../base';

export interface IPumpingStationMotorType extends IBasicBaseClass {
    name : string;

    isActive : boolean;
}

export default class PumpingStationMotorTypeHelper extends BasicBaseHelper {
    public static readonly COLLECTION_NAME = 'pumping_station_motor_type';

    private static converter : firebase.firestore.FirestoreDataConverter<IPumpingStationMotorType> = {
        fromFirestore: (snapshot) => {
            return PumpingStationMotorTypeHelper.fromFirestoreDocument(snapshot);
        },
        toFirestore: (data : IPumpingStationMotorType) : firebase.firestore.DocumentData => {
            return PumpingStationMotorTypeHelper.toFirestoreDocument(data);
        },
    };

    public static fromFirestoreDocument(snapshot : firebase.firestore.DocumentSnapshot) : IPumpingStationMotorType {
        const result = super.fromFirestore(snapshot);
        const data = snapshot.data();

        if (!snapshot.exists || !result || !data) throw new Error(`Document does not exist! ${snapshot.id}`);
        return {
            ...data as IPumpingStationMotorType,
            ...result,
        };
    }

    public static toFirestoreDocument(data : IPumpingStationMotorType) {
        const result = super.toFirestore(data);
        const { id: _id, ...rest } = data;

        return {
            ...rest,
            ...result,
        };
    }

    public static doc(id ?: string) {
        if (!id) {
            return firebaseApp.firestore().collection(PumpingStationMotorTypeHelper.COLLECTION_NAME).withConverter(PumpingStationMotorTypeHelper.converter).doc();
        }

        return firebaseApp.firestore().collection(PumpingStationMotorTypeHelper.COLLECTION_NAME).withConverter(PumpingStationMotorTypeHelper.converter).doc(id);
    }

    public static save(company : IPumpingStationMotorType) {
        return PumpingStationMotorTypeHelper.doc(company.id).set(company, {
            merge: true,
        });
    }
    
    public static collection() {
        return firebaseApp
            .firestore()
            .collection(PumpingStationMotorTypeHelper.COLLECTION_NAME)
            .withConverter(PumpingStationMotorTypeHelper.converter);
    }
}